export function getChildParts(resourceid: string){
  const query = [
    "SELECT ?part ?title ?level ?order ?structureType ?questionTitle ?author ?authorTitle ?isPartOf ?isPartOfTitle ",
    "{",
      "<" + resourceid + "> <http://purl.org/dc/terms/hasPart> ?part . ",
      "?part <http://purl.org/dc/elements/1.1/title> ?title .",
      "OPTIONAL {",
        "?isPartOf <http://purl.org/dc/terms/hasPart> <" + resourceid + "> .",
        "?isPartOf <http://purl.org/dc/elements/1.1/title> ?isPartOfTitle .",
      "}",
      "OPTIONAL {",
        "?part <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
        "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
      "}",
      "OPTIONAL",
      "{",
      "?part <http://scta.info/property/level> ?level .",
      "}",
      "OPTIONAL",
      "{",
      "?part <http://scta.info/property/structureType> ?structureType .",
      "}",
      "OPTIONAL",
      "{",
        "{",
          "?part <http://scta.info/property/sectionOrderNumber> ?order .",
        "}",
        "UNION",
        "{",
          "?part <http://scta.info/property/isTranscriptionOf> ?mpart . ",
          "?mpart <http://scta.info/property/isManifestationOf> ?epart . ",
          "?epart <http://scta.info/property/sectionOrderNumber> ?order .",
        "}",
        "UNION",
        "{",
          "?part <http://scta.info/property/isManifestationOf> ?epart . ",
          "?epart <http://scta.info/property/sectionOrderNumber> ?order .",
        "}",
      "}",
      "OPTIONAL",
      "{",
      "?part <http://scta.info/property/questionTitle> ?questionTitle .",
      "}",
    "}",
    "ORDER BY ?order ?authorTitle"].join('');
    return query
  }